import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteSystemsFromAPI, fetchSystemsFromAPI, fetchAllSystemsFromAPI, uploadSystemFileToAPI } from "../../../services/SystemService";



export const fetchAllSystems = createAsyncThunk(
  "systems/fetchAllSystems",
  async ({  }, { rejectWithValue }) => {
    try {
      const response = await fetchAllSystemsFromAPI();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data pengguna");
    }
  }
);

export const fetchSystems = createAsyncThunk(
  "systems/fetchSystems",
  async ({ page, perPage, search, columnFilters, sort }, { rejectWithValue }) => {
    try {
      const response = await fetchSystemsFromAPI(page, perPage, search, columnFilters, sort);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data pengguna");
    }
  }
);


export const deleteSystem = createAsyncThunk(
  "systems/deleteSystem",
  async ({config_key, config_type}, { rejectWithValue }) => {
    try {
      console.log("Redux deleteSystem called with:", { config_key, config_type });
      const response = await deleteSystemsFromAPI(config_key, config_type);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data pengguna");
    }
  }
);

// Upload System File
export const uploadSystemFile = createAsyncThunk(
  "systems/uploadSystemFile",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await uploadSystemFileToAPI(formData);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error?.message || "Upload gagal.",
        detail: error?.detail || [],
        status: error?.status || "failed"
      });
    }
  }
);


const systemSlice = createSlice({
  name: "systems",
  initialState: {
    systems: [],
    AllSystems:[],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    systemSearch: "",
    loading: false,
    error: null,
    totalCount:0,
    active: 0,
    types: 0,
    keywordSearch:"",
    columnFilters: {} // New state for column-specific filters
  },
  reducers: {
    setSearchSystem: (state, action) => {
      state.systemSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = action.payload;
    },
    resetSystemState: (state) => {
      state.systems = [];
      state.currentPage = 1;
      state.loading = false;
      state.error = null;
      state.keywordSearch = '';
      state.columnFilters = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSystems.pending, (state) => {
        console.log('🔄 fetchSystems.pending - setting loading to true');
        state.loading = true;
      })
      .addCase(fetchSystems.fulfilled, (state, action) => {
        console.log('✅ fetchSystems.fulfilled - received data:', action.payload);
        const response = action.payload;
        const systems = response.configs;
        state.loading = false;
        state.systems = systems.data || systems; // Handle both paginated and non-paginated responses
        state.currentPage = systems.current_page || 1;
        state.lastPage = systems.last_page || 1;
        state.perPage = systems.per_page || 10;
        state.firstItem = systems.from || 1;
        state.totalCount = systems.total || (systems.data ? systems.data.length : systems.length);
        state.active = systems.active ?? 0;
        state.types = systems.types ?? 0;
        console.log('✅ fetchSystems.fulfilled - final state:', {
          systemsCount: state.systems.length,
          loading: state.loading,
          totalCount: state.totalCount
        });
      })
      .addCase(fetchSystems.rejected, (state, action) => {
        console.log('❌ fetchSystems.rejected - error:', action.payload);
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAllSystems.fulfilled, (state, action) => {
        const systems = action.payload.systems;
        state.AllSystems = systems.data;
      })
      .addCase(deleteSystem.fulfilled, (state, action) => {
        state.systems = state.systems.filter(system => system.id !== action.payload);
      })
      .addCase(deleteSystem.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(uploadSystemFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadSystemFile.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally refresh the system list after successful upload
        // You can dispatch fetchSystems here if needed
      })
      .addCase(uploadSystemFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSearchSystem, setPage, setVisibilityFilter, setPerPage, setKeywordSearch, setColumnFilters, resetSystemState } = systemSlice.actions;
export default systemSlice.reducer;
